import React, { Fragment } from 'react';
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";
import useListboxFetch from "./useListboxFetch";
import { CommonDropdown } from "./CommonDropdown";
import {Globals} from "root/DataFunctions/BaseDataFns";

const DropdownSchoolGroups = ({ control, name, rules, placeholder, isSearchable, isClearable, isMulti, readOnly, authority_id, includeNone } ) =>
{
    const addNone = ( recs ) =>
    {
        if ( includeNone === true )
        {
            return [ ...recs, { value: 0, label: 'No Group' }]
        }
        else
        {
            return recs ;
        }
    }

    const fields = { url: '/schoolgroups?authorityid='+authority_id, keyFieldName: 'school_group_id', labelFieldName: 'school_group_name', postProcessingFn :addNone};

    const [ loading, items ] = useListboxFetch( fields ) ;

    return (
        <Fragment>
            { loading === true && <div className='form-control'><SpinnerDiv/></div> }
            { loading === false && <CommonDropdown items={items} control={control} name={name} rules={rules} placeholder={placeholder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly} /> }
        </Fragment>
    )
}

export default DropdownSchoolGroups;
